import { Task } from "@redux-saga/types";
import { ActionPattern, cancel, fork, getContext, setContext, takeEvery } from "redux-saga/effects";

type Tasks = Record<string, Task>;

function* internalWorker<Fn extends (...args: any[]) => any>(
  worker: Fn,
  getKey: (...args: Parameters<Fn>) => string,
  ...args: Parameters<Fn>
) {
  const tasks: Tasks = yield getContext("takeLatestByTasks");
  const key = getKey(...args);
  const previousTask = tasks[key];
  if (previousTask) {
    yield cancel(previousTask);
  }

  tasks[key] = yield fork(worker, ...args);
}

function* takeLatestByHelper<P extends ActionPattern, Fn extends (...args: any[]) => any>(
  pattern: P,
  worker: Fn,
  getKey: (...args: Parameters<Fn>) => string
) {
  const takeLatestByTasks: Tasks = yield getContext("takeLatestByTasks");
  if (!takeLatestByTasks) {
    yield setContext({ takeLatestByTasks: {} });
  }
  yield takeEvery(pattern, internalWorker, worker, getKey);
}

export function takeLatestBy<P extends ActionPattern, Fn extends (...args: any[]) => any>(
  pattern: P,
  worker: Fn,
  getKey: (...args: Parameters<Fn>) => string
) {
  return fork(takeLatestByHelper, pattern, worker, getKey);
}
